/**
 * @Author proudlx
 * @Description 人才认证请求接口路径
 */
/** banner */
export const POST_CERT_BANNERS = "/api/home/cert/banners";
/** cert banner v2 */
export const POST_CERT_V2_BANNERS = "/api/home/cert/v2/banners";
/** 认证信息列表 */
export const POST_CERTIFICATE_LIST = "/api/certificateInfos/list";
/** 首页认证列表 */
export const POST_CERTIFICATE_HOME_LIST = "/api/certificateInfos/homeList";
/** 认证证书查询 */
export const POST_CERTIFICATE_QUERY = "/api/student/certificate/query";
/** 认证课程与邀请码绑定 */
export const POST_CERTIFICATE_CHECKINVITE_CODE = "/api/certificateInfos/checkInviteCode";
/** 认证课程支付核销报名 */
export const POST_CERTIFICATE_CHECK_PAY_MENT = "/api/certificateInfos/checkPayment";

/** 注册报名 */
export const POST_CERTIFICATE_TOREGISTER = "/api/student/certificate/v2/toRegister";
export const POST_CERTIFICATE_TOEXAM = "/api/student/certificate/toExam";
export const POST_CERTIFICATE_UPDATE_EXAM = "/api/student/certificate/toUpdateExam";
/** 认证证书信息 */
export const POST_CERTIFICATE_INFO = "/api/certificateInfos/byCert";
/** 服务商列表 */
export const POST_BASE_ISPLIST = "/api/base/ispList";
/** 服务商身份报名 */
export const POST_LOGIN_ISP = "/api/login/isp";

//内部员工 toRegister
export const POST_TOREGISTER = "/api/student/certificate/staff/toRegister";
